import React from 'react';
import { HotkeyButtonStyles } from '@dealstack/frontend/shared/components/HotkeyButton/HotkeyButton.styles.tsx';
import { OsCheck } from '@dealstack/frontend/shared/hooks/useOs/useOs.hook.ts';
import { useHotkeys } from '@mantine/hooks';
import { Text } from '@mantine/core';

interface HotkeyButtonProps {
	osCheck: OsCheck;
	macHotkey: HotkeyProps;
	otherHotkey: HotkeyProps;
	onClick: () => void;
}

export const HotkeyButton = ({ osCheck, macHotkey, otherHotkey, onClick }: HotkeyButtonProps) => {
	const hotkey = osCheck.os === 'mac' ? macHotkey : otherHotkey;

	useHotkeys([[hotkey.combo, () => onClick()]]);

	return (
		<HotkeyButtonStyles>
			<Text fz="xs" className="text">
				{hotkey.text}
			</Text>
		</HotkeyButtonStyles>
	);
};

interface HotkeyProps {
	combo: string;
	text: string;
}
